import { gql } from '@apollo/client';

import { ADS_PAGE_AD } from '../../../../../../../common/AdForm/hooks/fragments/adFragments';
import { AD_TRAFFICKING_COLUMN } from '../../../../../TraffickingPage/hooks/fragments/adFragments';

export const CREATE_ADS_BATCH = gql`
  mutation CreateBatchAds($adsInput: [AdInputV5!]!) {
    createAdsBatchV5(ads: $adsInput) {
      ...adsPageAd
      ...adTraffickingColumn
    }
  }
  ${ADS_PAGE_AD}
  ${AD_TRAFFICKING_COLUMN}
`;
